import { useMsal, } from '@azure/msal-react';
import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { DateTime } from 'luxon';
import LoadingAnimation from "../loading/loading";
import XeroApi from '../../api/xero/xero-api-factory';
import { arrayAny } from '../../utils/arrayUtils';

export const XeroIntegrationTab = ({ company }) => {

    const [contacts, setContacts] = useState(null);

    const navigate = useNavigate();
    const { instance, inProgress, accounts } = useMsal();
    const xeroApi = useMemo(() => new XeroApi(instance, inProgress, accounts, false), [instance, inProgress, accounts]);

    useEffect(() => {

        async function fetchData() {
            const result = await xeroApi.getContacts(company.id);
            setContacts(result);
        }

        if (company && company.xero && howLongUntilExpiry(company.xero.refreshTokenExpiresAtUtc) > 0) {
            fetchData();
        }
    }, [company, xeroApi]);

    const handleLink = link => {

        const r = new RegExp("^(?:[a-z]+:)?//", "i");
        if (r.test(link.link)) {
            // URL is absolute
            window.open(link.link, link.target);
            return;
        } else {
            // URL is relative
            navigate(link.link);
            return;
        }
    };

    const getXeroLinkUrl = async companyId => {
        const result = await xeroApi.getAuthLink(companyId);
        handleLink({ link: result, target: '_self' });
    };

    const howLongUntilExpiry = expiry => {
        const now = DateTime.now();
        const expiryDateTime = DateTime.fromISO(expiry);
        const diff = expiryDateTime.diff(now, 'days');
        return Math.floor(diff.days);
    };

    return (
        <>
            <div className="row">
                <div className="col-md-3">
                    <h3>Link to Xero</h3>
                    <p>Link your company to Xero to enable invoicing and payment collection.</p>
                    <button type='button' className='btn btn-primary' onClick={() => getXeroLinkUrl(company.id)}>Connect To Xero</button>
                </div>
                {arrayAny(contacts) ? <div className="col-md-6">
                    <h3>Xero Contacts</h3>
                    <p>This data comes from Xero, if you see it, you are connected...</p>
                    {contacts.slice(0, 10).map(contact =>
                        <div key={contact.xeroContactId}>{contact.contactName}</div>
                    )}
                </div> :
                    <div className="col-md-6">
                        <LoadingAnimation />
                    </div>
                }
            </div>
            <div className="row">
                <div className="col-md-3">
                    {company && company.xero && company.xero.refreshTokenExpiresAtUtc && <span className='mt-5px'>
                        Your current link to Xero will require re-authentication in {howLongUntilExpiry(company.xero.refreshTokenExpiresAtUtc)} days.
                    </span>}
                </div>
            </div>
        </>
    );

};